module.exports = __webpack_public_path__ + "img/photo_lucille.e122bfa0.png";